import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'axios';
import { UsersService } from 'src/app/services/users/users.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { LoadingScreenComponent } from '../../../shared/loading-screen/loading-screen.component';

@Component({
  selector: 'app-sso-redirect',
  templateUrl: './sso-redirect.component.html',
  styleUrls: ['./sso-redirect.component.scss'],
  imports: [LoadingScreenComponent],
})
export class SsoRedirectComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private router = inject(Router);
  private usersService = inject(UsersService);

  async ngOnInit() {
    const code = this.route.snapshot.queryParams.code;
    if (!code) {
      this.router.navigateByUrl('login');
      return;
    }
    try {
      this.authService.logoutOnUnauthorized = false;
      const response = await axios.get<{ is_new: boolean }>(
        `${environment.baseUrl}/api/auth/sso/google/callback`,
        {
          params: {
            code,
          },
        },
      );

      if (response.data.is_new) {
        this.authService.setNext('/case');
      }

      await this.usersService.setUser();
      await this.router.navigateByUrl(environment.afterLoginPath);
    } catch (error) {
      console.error('Error while loggin in with google sso', error);
      this.router.navigateByUrl('login');
    } finally {
      this.authService.logoutOnUnauthorized = false;
    }
  }
}
